import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { AUTH_PREFIX_PATH, AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { fetchMe, selectAuthUser } from 'store/slices/authSlice';

import { canAccessRoute } from 'utils/permissions';
import Loading from 'components/shared-components/Loading';

const SELECT_COMPANY_PATH = `${AUTH_PREFIX_PATH}/select-company`;

const AppRoute = ({ component: Component, routeKey, ...props }) => {
  const dispatch = useDispatch();

  const user = useSelector(selectAuthUser);
  const token = useSelector((s) => s.auth.token);
  const userLoading = useSelector((s) => s.auth.userLoading);

  useEffect(() => {
    if (token && !user && !userLoading) {
      dispatch(fetchMe());
    }
  }, [token, user, userLoading, dispatch]);

  const perm = props?.perm || props?.meta?.perm;
  const superAdminOnly = !!props?.meta?.superAdminOnly;
  const needsAuth = !!perm || superAdminOnly;

  if (needsAuth && !token) {
    return <Navigate to={`${AUTH_PREFIX_PATH}/login`} replace />;
  }

  if (token && !user) {
    return <Loading cover="content" />;
  }

  const isGlobalAdmin = !!user?.isGlobalAdmin;

  if (token && user && !superAdminOnly && !isGlobalAdmin) {
    const lsCompanyId = localStorage.getItem('companyId');
    const activeCompanyId = user?.activeCompanyId;

    const isOnSelectCompany =
      window.location.pathname === SELECT_COMPANY_PATH;

    const needsCompany = !lsCompanyId && !activeCompanyId;

    if (needsCompany && !isOnSelectCompany) {
      return <Navigate to={SELECT_COMPANY_PATH} replace />;
    }

    if (!lsCompanyId && activeCompanyId) {
      localStorage.setItem('companyId', String(activeCompanyId));
    }
  }

  if (superAdminOnly && user && !isGlobalAdmin) {
    return <Navigate to={AUTHENTICATED_ENTRY} replace />;
  }

  if (needsAuth && user && !isGlobalAdmin) {
    const allowed = canAccessRoute(user, props);

    if (!allowed) {
      return <Navigate to={AUTHENTICATED_ENTRY} replace />;
    }
  }

  return <Component {...props} routeKey={routeKey} />;
};

export default AppRoute;